import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ListForm } from '../../../../base/controlers/list-form';
import { DecorType } from '../../models/decor-type';
import { DecorTypeService } from '../../services/decor-type.service';

@Component({
  selector: 'app-decor-type-list',
  templateUrl: './decor-type-list.component.html',
  styleUrls: ['./decor-type-list.component.css']
})
export class DecorTypeListComponent extends ListForm<DecorType> implements OnInit {
  
  public displayedColumns = ['actions','code','name'];
  constructor(
    protected decorTypeService: DecorTypeService,
    protected router:Router    
  ) { 
    super(decorTypeService,'/plasard-measurement/decor-type',router);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
